import { useId } from 'react'
import { Pill, Select, VisuallyHidden } from 'admination-react'
import { ENDONYMS, LANGUAGES, isLanguage, type Language } from '@/core/i18n'

const OPTIONS = LANGUAGES.map((language) => ({ value: language, label: ENDONYMS[language], lang: language }))

export function LanguageSwitcher({
  value,
  label,
  onChange,
  disabled,
}: {
  value: Language

  label: string
  onChange: (language: Language) => void
  disabled?: boolean
}) {
  const id = useId()
  return (
    <Pill>
      <VisuallyHidden as="label" htmlFor={id}>
        {label}
      </VisuallyHidden>
      <Select
        id={id}
        compact
        icon="i-globe"
        options={OPTIONS}
        value={value}
        disabled={disabled}
        onChange={(next) => {
          if (isLanguage(next)) onChange(next)
        }}
      />
    </Pill>
  )
}
